// extracted by mini-css-extract-plugin
export default {"infoIconContainer":"SafeArea_infoIconContainer__6+0aS","infoIcon":"SafeArea_infoIcon__0zDml"};